import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { formatDate, numberOfDaysTillPermDelete } from '../../common/gridHelpers';
import { SCellNotification, SCellNotificationText } from '../message-center/styles/GridCellDate.styled';

interface IProps {
  date: Date;
  isExpireDate?: boolean;
  includeTimeStamp?: boolean;
}

const GridCellDate: React.FC<IProps> = ({ date, isExpireDate, includeTimeStamp = false }) => {
  if (!date) {
    return <td colSpan={1} role="gridcell" aria-selected="false" />;
  }
  if (isExpireDate && numberOfDaysTillPermDelete(date) <= 14) {
    return (
      <td colSpan={1} role="gridcell" aria-selected="false">
        <SCellNotification>
          {formatDate(date)}
          <SCellNotificationText>
            <FontAwesomeIcon icon={faCircleExclamation} /> {numberOfDaysTillPermDelete(date)} days left
          </SCellNotificationText>
        </SCellNotification>
      </td>
    );
  }

  return (
    <td colSpan={1} role="gridcell" aria-selected="false">
      {formatDate(date, includeTimeStamp)}
    </td>
  );
};

export default GridCellDate;
